(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-responsive-slideshow')) {
    class PLResponsiveSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.speed = Number(this.dataset.speed) || 5000;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this._visibilityListener = () => { if (document.hidden) this.stop(); else this.start(); };
        document.addEventListener('visibilitychange', this._visibilityListener);
        this._touchStartX = null;
        this._touchStartY = null;
        this.addEventListener('touchstart', (e) => { if(e.touches.length !== 1) return; this._touchStartX = e.touches[0].clientX; this._touchStartY = e.touches[0].clientY; this.stop(); }, { passive:true });
        this.addEventListener('touchend', (e) => { if(this._touchStartX === null || !e.changedTouches.length) return; const dx=e.changedTouches[0].clientX-this._touchStartX; const dy=e.changedTouches[0].clientY-this._touchStartY; this._touchStartX=null; this._touchStartY=null; if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.4){ this.go(this.index+(dx<0?1:-1)); } else { this.start(); } }, { passive:true });

        this.start();
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this._visibilityListener);
        this.stop();
      }

      go(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          slide.hidden = index !== this.index;
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.slides.length < 2 || document.hidden) return;
        this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('pl-responsive-slideshow', PLResponsiveSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
